/* eslint-disable sort-keys */
import {
    ErrorProps,
} from './types'
import ErrorView from './ErrorView'
import React from 'react'
import {useTranslation} from 'react-i18next'
const LoginError: React.FC<ErrorProps> = (props: ErrorProps): React.ReactElement => {
    const {t} = useTranslation()
    const {errorMessage} = props
    const messages = {
        // Access errors
        access_denied: t('Access denied. Please check your credentials and try again'),
        access_expired: t('Please sign in again'),
        access_blocked: t('Your network connection address is blocked. Please check your network settings or contact your support for assistance'),
        access_already_spent: t('Access key has already been used'),
        // Session errors
        session_not_found: t('Session not found'),
        // Identity errors
        identity_not_found: t('Account not found. Please check your credentials or create a new account'),
        identity_already_exists: t('Identity already exists'),
        // Permission errors
        permission_denied: t('Permission denied'),
        permission_expired: t('Permission expired'),
        permission_already_spent: t('Permission has already been used'),
    }
    // Return the translated message if the error code exists in messages,
    // otherwise return the original error from backend and show
    const currentMessage = messages[errorMessage as keyof typeof messages] ?? errorMessage
    return (
        <ErrorView errorMessage={currentMessage} />
    )
}
export default LoginError

